export default [{
  path: '/package/index',
  name: 'package-index',
  title: '财务',
  // redirect: '/package/index',
  component: () => import('@/views/package/index'),
  children: [{
    path: '/package/overview',
    name: 'package-overview',
    title: '套餐分析',
    component: () => import('@/views/package/template/overview')
  }, {
    path: '/package/sales',
    name: 'package-sales',
    title: '套餐分析',
    component: () => import('@/views/package/template/sales')
  }, {
    path: '/package/deduction',
    name: 'package-deduction',
    title: '套餐分析',
    component: () => import('@/views/package/template/deduction')
  }]
}];
